import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {

  constructor(private activatedRoute: ActivatedRoute, private service: UserService, private router: Router, private toaster: ToastrService) { }

  token = "";
  password = "";
  password2 = "";

  errorMsg = "";

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(d=>{
      this.token  = d.t;
      
    })
  }

  confirm(){
    this.errorMsg = "";
    if(this.password.length<4){
      this.errorMsg = "Las contraseñas debe tener al menos 4 caracteres.";
      return;
    }
    if(this.password!=this.password2){
      this.errorMsg = "Las contraseñas ingresadas no coinciden.";
      return;
    }
    this.service.updatePassword(this.token,this.password).subscribe(d=>{
      this.router.navigate(['/login']);
    }, err=>{
      this.toaster.error( err.error,"Error");
    })
  }

}
